import type { Session as NextAuthSession } from 'next-auth';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { mountAuthHeaders } from '~/shared/auth/mountAuthHeaders';
import { genomeApi } from '~/shared/services/api';

export const GET_EMPLOYEE_BASIC_INFO_QUERY_KEY = 'useGetEmployeeBasicInfo';

type EmployeeBasicInfo = {
  globalId: string;
  name: string;
  email: string;
  position: string;
};

export async function getEmployeeBasicInfo({
  employeeGlobalId,
  session,
}: {
  employeeGlobalId: string;
  session?: NextAuthSession | null;
}) {
  if (!employeeGlobalId || employeeGlobalId === '') {
    return null;
  }
  const response = await genomeApi.get<EmployeeBasicInfo>(
    `/employee/${employeeGlobalId}`,
    {
      headers: mountAuthHeaders(session),
    }
  );

  return response.data;
}

export function useGetEmployeeBasicInfo<T = EmployeeBasicInfo | null>(
  employeeGlobalId: string,
  queryOptions?: UseQueryOptions<EmployeeBasicInfo | null, unknown, T, string[]>
) {
  return useQuery({
    retry: false,
    queryKey: [GET_EMPLOYEE_BASIC_INFO_QUERY_KEY, employeeGlobalId],
    queryFn: () => getEmployeeBasicInfo({ employeeGlobalId }),
    ...queryOptions,
  });
}
